<mat-menu #childMenu="matMenu" [overlapTrigger]="false" class="wide">
  <h4 class="menu-item-title">
    <span>{{ parent.title | translate }}</span>
    <mat-icon>{{ parent.titleIcon }}</mat-icon>
  </h4>

  @for (child of items; track child) {
    <section>
      <!-- Handle branch node menu items -->
      @if (child.children && child.children.length > 0) {
        <section>
          <a class="menu-item-button" mat-menu-item [matMenuTriggerFor]="menu.childMenu">
            {{ child.displayName }}
            @if (child?.icon) {
              <mat-icon class="menu-item-icon">{{ child.icon }}</mat-icon>
            }
          </a>
          <app-menu-item #menu [parent]="child" [items]="child.children" (navItemClicked)="onNavItemClicked($event)"></app-menu-item>
        </section>
      }
      <!-- Handle leaf node menu items -->
      @if (!child.children || child.children.length === 0) {
        <section>
          <a class="menu-item-button" mat-menu-item [href]="child.route" (click)="onNavItemClicked(child)" [class.active]="child.active" [disabled]="child.active">
            {{ child.displayName }}
            @if (child?.icon) {
              <mat-icon class="menu-item-icon">{{ child.icon }}</mat-icon>
            }
          </a>
        </section>
      }
    </section>
  }
</mat-menu>
